import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';

export default class KiDsPwaView extends KiDsPwaComponent {
    constructor() {
        super();
        this.channelId = '';
    }

    static get properties() {
        return {
            channelId: { type: String },
        };
    }

    _setDocumentTitle(channel) {
        document.title = channel?.name ?? 'datasphere';
    }

    _dispatchChannelLoaded(channel) {
        this.dispatchEvent(
            new CustomEvent('channel-loaded', {
                detail: { channel },
                bubbles: true,
                composed: true,
            }),
        );
    }
}
